<template>
  <div class="list-message">
    <div ref="contentWrap" class="scroll-view-box" @scroll="onScroll">
      <div class="message-scroll">
        <div
          v-for="item in currentMessageList"
          :id="'item' + item.ID"
          :key="item.ID"
          class="list-wrap"
        >
          <!-- 系统时间 showTime 前端自定义字段-->
          <!-- <im-system v-if="isShowImTime(index)" :message="item" /> -->
          <im-system v-if="item.showTime" :message="item" />
          <!-- 消息体 hideMessage 前端自定义字段 im-system 用于显示：您撤回了一条消息，您删除了一条消息-->
          <div v-if="item.from === '@TIM#SYSTEM'"></div>
          <im-message
            v-else-if="!item.isRevoked && !item.isDeleted && !isCustomTxt(item.payload)"
            :message="item"
            :message-list="currentMessageList"
            @play="onPlay"
            @menu="onLongpress"
          />
          <im-revoke v-else :message="item" />
        </div>
        <div v-if="isCompleted && currentMessageList.length" class="no-message">没有更多啦</div>
      </div>
    </div>
    <uni-popups
      v-model="revokeItem"
      :popData="popData"
      :x="popPoint.x"
      :y="popPoint.y"
      placement="top"
      @clickPopup="tapPopup"
    />
    <audio
      :src="audioUrl"
      @canplay="onCanplay"
      @ended="stopAudio"
      @error="onError"
      ref="audioRef"
    ></audio>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { TIM_TYPE, getMessageList, revokeMessage, setMessageRead } from '@/timpackage/utils/timInit'
// const Audio = uni.createInnerAudioContext() // 放到data中就报错了，不能用proxy绑定这个对象
const Audio = {
  on() {}
}
export default {
  props: {},
  data() {
    return {
      audioUrl: '',
      canplay: false,
      playCb: null,
      playing: false,
      scrollRandom: -1,
      isLoading: false,
      scrollToView: '',
      revokeItem: false,
      popPoint: { x: 0, y: 0 },
      popData: [
        // { title: '撤回', type: 'revoke' },
        { title: '复制', type: 'copy' }
      ],
      catchTime: 0,
      catchScrollTop: 0
    }
  },
  computed: {
    ...mapState('IM/message', [
      'currentMessageList',
      'conversationId',
      'isSendMessage',
      'isCompleted'
    ]),
    ...mapState('IM', ['isRecording'])
  },
  watch: {
    currentMessageList: {
      handler(n, o) {
        this.isSendMessage && this.goTop()
        this.isLoading = false
        this.setLastMessage(false)
      },
      immediate: true
    },
    isRecording(n) {
      n && this.stopAudio()
    }
    // conversationId(n, o) {
    //   // 切换会话清空列表
    //   if (n !== o) {
    //     this.resetList()
    //   }
    // }
  },
  mounted() {
    // Audio.onEnded(() => {
    //   // 播放结束关闭当前动画
    //   this.catchPlay && this.catchPlay.end()
    // })
    // console.log('im-list-messsage------', this.conversationId)
    this.initList()
  },
  beforeDestroy() {
    this.stopAudio() // 离开im关闭语音播放
    setMessageRead(this.conversationId)
  },
  methods: {
    ...mapMutations('IM/message', ['resetList', 'setLastMessage']),
    isShowImTime(i) {
      if (i === 0) {
        return true
      }
      const t1 = this.currentMessageList[i - 1].time
      const t2 = this.currentMessageList[i].time
      if (t2 - t1 > 5 * 60) {
        return true
      }
    },
    goTop() {
      this.scrollToView = ''
      this.$nextTick(() => {
        // this.scrollToView = 0
        this.conversationId && setMessageRead(this.conversationId) // 查看消息后设置消息已读
        /**
         * 自己发送消息才会让滚动调到初始位置,
         * 如果联系发送消息初始位置都是0页面不能即时更新，
         * 添加随机数保证没次发消息都会更新
         * **/
        if (this.$refs.contentWrap) {
          this.scrollRandom %= 2
          this.scrollRandom--
          this.$refs.contentWrap.scrollTo(0, this.scrollRandom)
        }
      })
    },
    async onScroll(e) {
      // 设计成这么复杂是为了下拉加载更多追加数据页面不抖动
      const scrollHeight = e.target.scrollHeight // 内容高度,由于margin会有误差
      const scrollTop = e.target.scrollTop // 滚动条距离顶部距离，由于列表设置了flex-direction: column-reverse;,实际是距离底部距离
      const height = e.target.getBoundingClientRect().height
      // 消息列表滚动到顶部30px后，开始加载历史数据
      if (scrollHeight - height - scrollTop <= 30 && !this.isLoading) {
        this.isLoading = true // 这个标识必须等到数据请求结束页面渲染结束后才能请求下一页
        await getMessageList()
      }
    },
    initList() {
      const fn = async () => {
        // 加载第一页, 解决大屏一页不能触发滚动
        this.isLoading = true
        this.setLastMessage(true)
        await getMessageList()
        this.isLoading = false
        this.setLastMessage(false)
      }
      fn()
    },
    onLongpress({ info, message: item }) {
      const disTime = Math.floor(new Date().getTime() / 1000) - item.time
      const popData = []
      if (disTime < 60 * 2 && item.flow === 'out') {
        // 只能撤回自己发的2分钟内消息
        popData.push({ title: '撤回', type: 'revoke' })
      }
      if (item.type === TIM_TYPE.MSG_TEXT) {
        // 只能复制文本消息
        popData.push({ title: '复制', type: 'copy' })
      }
      this.popData = popData
      // 复制、撤回都没有就不弹框
      if (!popData.length) {
        return
      }
      this.revokeItem = item
      this.popPoint = Object.assign(info, {
        x: info.left + info.width / 2,
        y: info.top
      })
    },
    // 复制
    onCopyMessage(message) {
      const payload = message.payload || { text: '' }
      if (!payload || !payload.text) {
        return
      }
      // uni.setClipboardData({
      //   data: payload.text,
      //   success: () => {
      //     console.log('success')
      //   },
      //   fail: err => {
      //     console.log('fail')
      //   }
      // })
    },
    tapPopup({ type }) {
      if (type === 'revoke') {
        revokeMessage(this.revokeItem)
      }
      if (type === 'copy') {
        this.onCopyMessage(this.revokeItem)
      }
    },
    onPlay({ message, cb }) {
      this.playCb = cb
      this.handleAudio(message.payload, cb)
    },
    //控制播放还是暂停音频文件
    handleAudio(item, cb) {
      // console.log(item, Audio.src)
      if (item.url === this.audioUrl && this.audioUrl) {
        if (this.playing) {
          this.$refs.audioRef.pause()
          cb && cb.end()
          this.playing = false
        } else {
          this.$refs.audioRef.play()
          cb && cb.start()
          this.playing = true
        }
        return
      }
      this.playAudio(item)
      cb && cb.start()
      this.playing = true
    },
    onCanplay() {
      this.canplay = true
      this.$refs.audioRef.play()
    },
    //播放音频
    playAudio(item) {
      this.audioUrl = item.url
      // item.url = 'https://www.w3school.com.cn/i/audio/song.mp3'
      // this.audioUrl = 'https://www.w3school.com.cn/i/audio/song.mp3'
    },
    stopAudio(e) {
      this.playCb && this.playCb.end()
      this.audioUrl = ''
      this.playing = false
    },
    onError(e) {
      if (this.audioUrl && this.playCb) {
        this.stopAudio()
        this.playCb && this.playCb.end()
      }
    },
    isCustomTxt(payload) {
      // 是否是自定义消息-文本
      if (!payload || !payload.data) {
        return false
      }
      let data = payload.data
      try {
        // if (data && typeof data === 'string') {
        data = JSON.parse(data) || {}
        if (['98', '99', '100'].includes(String(data.type))) {
          return true
        }
        if (data && data.data) {
          // 在这里把视频通话插件中自定义消息分到提示消息中
          const target = JSON.parse(data.data)
          if (target.businessID === 'av_call' && !target.userData) {
            return true
          }
        }
      } catch (e) {
        console.log(e)
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
/**
列表先再列表中间x方向旋转180deg，
里面每项也按x方向旋转180deg
这样修复列表在签名添加数据抖动问题
**/
.list-message {
  position: relative;
  height: 100%;
  transform: rotateX(180deg);
  transform-origin: 0 center;

  .scroll-view-box {
    // position: absolute;
    // top: 0;
    // right: 0;
    // bottom: 0;
    // left: 0;
    // transform-origin: center center;
    // transform: rotateX(180deg);
    // z-index: 1;
    // height: 100%;
    // overflow-anchor: none;
    // max-height: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    .no-message {
      position: relative;
      transform-origin: center center;
      transform: rotateX(180deg);
      z-index: 1;
      text-align: center;
      width: 100%;
      font-size: 0.512rem;
      line-height: 0.853333rem;
      color: #6e7981;
      height: 0.853333rem;
    }

    .message-scroll {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      min-height: 100%;

      .list-wrap {
        position: relative;
        transform-origin: center center;
        transform: rotateX(180deg);
        z-index: 1;
      }
    }
  }
}
</style>
